import { type Activity, ActivityStatus } from '@/data/idp/plans/interfaces';

export const activitiesAmountByStatus = (activities: Activity[]) => {
  const totalActivities = activities.length;

  const initialStatusCounts: Record<
    ActivityStatus,
    { quantity: number; percentage: number }
  > = {
    [ActivityStatus.InProgress]: { quantity: 0, percentage: 0 },
    [ActivityStatus.Completed]: { quantity: 0, percentage: 0 },
    [ActivityStatus.Pending]: { quantity: 0, percentage: 0 },
  };

  const statusCounts = activities.reduce((acc, activity) => {
    if (!acc[activity.status]) {
      acc[activity.status] = { quantity: 0, percentage: 0 };
    }
    acc[activity.status].quantity++;
    return acc;
  }, initialStatusCounts);

  for (const status of Object.keys(statusCounts) as ActivityStatus[]) {
    statusCounts[status].percentage =
      (statusCounts[status].quantity / totalActivities) * 100;
  }

  return statusCounts;
};
